import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Button from '@atlaskit/button';
import ChevronIcon from '@atlaskit/icon/glyph/chevron-down';
import { RenotifySpotlightTriggerChevron } from './styled';
const buttonStyles = css({
  padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`
});
function RenotifyMenuButton(props) {
  const {
    testId,
    triggerProps,
    children
  } = props;

  // The cloned spotlight button requires the className prop to be set
  // for the padding style to be applied properly
  return jsx(Button, _extends({
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "renotify-menu-button",
    css: buttonStyles,
    iconAfter: jsx(RenotifySpotlightTriggerChevron, null, jsx(ChevronIcon, {
      label: "dropdown-chevron"
    }))
  }, triggerProps), children);
}
export default RenotifyMenuButton;